class ManualCountAction{
    constructor({countedQuantity, additionalUnitsExpectedInd}){
        this.countedQuantity = countedQuantity;
        this.additionalUnitsExpectedInd = additionalUnitsExpectedInd;
    }
}

export { ManualCountAction };